module.exports = __webpack_public_path__ + "img/75325e6.jpg";